riot.tag2('bbc-notifications-drawer', '<section class="notification-error__container"> <bbc-notifications-error main="{opts.error.main}" inner="{opts.error.inner}"></bbc-notifications-error> </section> <div if="{opts.error.main != \'hub\' && opts.error.main != \'onboarding\'}"> <bbc-notifications-onboarding-async if="{opts.onboarding && !opts.idctaData.policyCheck}"></bbc-notifications-onboarding-async> <bbc-notifications-onboarding-u13 if="{opts.idctaData.policyCheck}" idcta-data="{opts.idctaData}" main-app="{this.parent.opts.mainApp}"></bbc-notifications-onboarding-u13> <div if="{!opts.onboarding && !opts.idctaData.policyCheck}"> <bbc-notifications-onboarding-u13-success if="{this.showU13Success}"></bbc-notifications-onboarding-u13-success> <div if="{opts.state === \'signed-in\'}" id="notifications-main" class="notifications__container notifications-{this.view} notifications-{this.view}--js notifications-main--css notification-signed-in"> <div if="{!opts.hasSetup}"> <div id="notifications-main"> <div class="spinner"> <img class="loader-icon notifications-image spinner__img--svg" riot-src="{this.basePath + \'/svg/loader.svg\'}" alt="Spinner"> </div> </div> </div> <div if="{opts.hasSetup}"> <div if="{this.view == \'settings\'}"> <bbc-notifications-settings if="{opts.error.main != \'settings\'}"></bbc-notifications-settings> </div> <div if="{this.view !== \'settings\'}"> <header id="notifications__header" class="notifications__header notifications__header--js {\'shadowAdded\': shadowAdded}"> <h2 class="notification-title"><i1-8n>Notifications</i1-8n></h2> <ul class="notification-header-icons"> <li><a href="javascript:;" class="notifications__settings--js" onkeydown="{this.onSettingsKeydown}" onclick="{this.openSettings}"><img class="setting-icon notifications-image" riot-src="{this.basePath + \'/svg/setting.svg\'}" alt="Settings"><span class="notifications-brevier"><i1-8n>Settings</i1-8n></span></a></li> </ul> </header> <div id="notifications-wrapper" onmousewheel="{this.onListMouseWheel}" onscroll="{this.onListScroll}"> <div class="notification-panel" style="display: block;"> <bbc-notifications-list notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}"></bbc-notifications-list> </div> </div> </div> </div> </div> <div if="{opts.state === \'signed-out\'}" id="notifications-main" class="notifications-main--css notifications-main--js notification-signed-out"> <div class="notifications-no-scroll"> <div class="notifications-wide-spread"> <div class="notifications__container"> <div class="notifications-top-header"> <p class="notifications-main-header notifications-trafalgar"><i1-8n>copy.upsell.title</i1-8n></p> <p class="notifications-description notifications-pica"><i1-8n>copy.upsell.body</i1-8n></p> </div> <div class="notifications-cta notifications-cta--upsell"> <bbc-notifications-idcta-html html="{opts.idctaData.html}" html-js="{opts.idctaData.htmlJs}"></bbc-notifications-idcta-html> </div> </div> </div> </div> </div> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var notificationsAnalytics = require('../analytics');

this.basePath = this.parent.opts.mainApp.basePath;
this.shadowAdded = false;
this.view = 'main';

var listShadowOffset = 0;
var loadMoreBuffer = 50;

if (typeof localStorage !== 'undefined') {
    if (opts.state === 'signed-in' && localStorage.getItem('bbc-notifications-u13-pending-policy')) {
        this.update({ showU13Success: true });
        localStorage.removeItem('bbc-notifications-u13-pending-policy');
    } else if (opts.state === 'signed-out') {
        localStorage.removeItem('bbc-notifications-u13-pending-policy');
    }
}

this.hideU13Success = function () {
    _this.update({ showU13Success: false });
};

this.openSettings = function () {
    notificationsAnalytics.log('click', 'notifications-settings');
    _this.update({ view: 'settings' });
};

this.closeSettings = function (e) {
    console.info('Close settings', e);

    _this.view = 'main';
    _this.update();

    return false;
};

this.trackUpsellSignIn = function () {
    notificationsAnalytics.log('sign-in', 'notifications-upsell');
    return true;
};

this.trackUpsellRegister = function () {
    notificationsAnalytics.log('register', 'notifications-upsell');
    return true;
};

this.loadMore = function () {
    // eslint-disable-line consistent-return
    console.log('Active element', document.activeElement);
    if (document.activeElement && document.activeElement.classList && (document.activeElement.classList.contains('notification-item--link') || document.activeElement.classList.contains('notifications-keyboard-access--btn'))) {
        return false;
    }

    if (!_this.opts.loadingMore && !_this.opts.reachedEnd) {
        console.warn('Load more...');
        _this.parent.fetchNotifications(true);
    }
};

// Calculate overflow block
this.onListMouseWheel = function (e) {
    e.preventUpdate = true;

    if (!opts.notifications.length) {
        return true;
    }

    if (e.currentTarget.offsetHeight >= e.currentTarget.scrollHeight) {
        return true;
    }

    if (e.deltaY > 0) {
        return !(e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight);
    }

    return !(e.currentTarget.scrollTop === 0);
};

this.onListScroll = function (e) {
    e.preventUpdate = true;

    // Calculate shadow
    if (!_this.shadowAdded && e.currentTarget.scrollTop > listShadowOffset) {
        _this.update({ shadowAdded: true });
    } else if (_this.shadowAdded && e.currentTarget.scrollTop <= listShadowOffset) {
        _this.update({ shadowAdded: false });
    }

    // Calculate load more
    if (e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight - loadMoreBuffer) {
        _this.loadMore();
    }
};

this.onSettingsKeydown = function (e) {
    console.log('Settings press', e);
    if (e.keyCode === 9 && e.shiftKey) {
        // Tab backwards
        var closeBtn = document.querySelector('.notifications-keyboard-access--close');

        if (closeBtn) {
            closeBtn.focus();
            return false;
        }

        var lastNotif = document.querySelector('.notification-items .notification-item:last-child a');

        if (lastNotif) {
            lastNotif.focus();
            return false;
        }
    } else if (e.keyCode === 13) {
        // Enter
        _this.updateFocus = '.notifications__settings__back-btn--js';
    } else if (e.keyCode === 9 && !e.shiftKey) {
        // Tab forwards
        if (!document.querySelectorAll('bbc-notifications-list .notification-item').length) {
            _this.update({ showKeyboardAccess: true });
        }
    }

    return true;
};

this.on('updated', function () {
    if (_this.updateFocus) {
        console.log('Updating focus', _this.updateFocus);

        var el = document.querySelector(_this.updateFocus);
        if (el) {
            el.focus();
        }

        _this.updateFocus = null;
    }

    _this.parent.opts.mainApp.updateDrawerHeight();
});

var requiresReset = void 0;
this.opts.componentApp.on('drawerStateChanged', function (state) {
    if (state === 'hidden') {
        requiresReset = true;
    } else if (requiresReset) {
        _this.update({ view: 'main' });
        requiresReset = false;
    }
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-drawer.tag
 ** module id = 18
 ** module chunks = 0
 **/